import React from 'react';
const { Fragment, useEffect, useState } = React;
import { useParams, useHistory } from 'react-router-dom';
import styles from './styles.scss';
import classnames from 'classnames';

import colorVariables from '@densityco/ui/variables/colors.json';

import BackButton from '../../BackButton';
import MoreButton from '../../MoreButton';
import AddSensorSidebar from '../AddSensorSidebar';

import { MultiPointInstallation } from '../../../types/api';
import { useRequiredSessionToken } from '../../../utils/session-token';
import { createMpis } from '../../../rx-actions/load-mpis';

import {
  Button,
  Icons,
  InputBox,
  AppBar,
  AppBarTitle,
  AppBarSection,
} from '@densityco/ui';
import Sidebar from '../../Sidebar';
import HorizontalForm from '../../HorizontalForm';

import MultiPointInstallationCreationStore from '../../../rx-stores/multi-point-installation-creation';
import {
  MultiPointInstallationCreationAction,
  MultiPointInstallationCreationActionTypes,
} from '../../../types/multi-point-installation-creation';

import useRxStore from '../../../utils/use-rx-store';
import useRxDispatch from '../../../utils/use-rx-dispatch';

import SensorRearranger from '../SensorRearranger';

const MultiPointInstallationCreationStepReorder: React.FunctionComponent<{}> = () => {
  const state = useRxStore(MultiPointInstallationCreationStore);
  const dispatch = useRxDispatch();
  const { organizationIdOrAll } = useParams();
  const history = useHistory();

  const sessionToken = useRequiredSessionToken();

  const [showSensorSidebar, setShowSensorSidebar] = useState(false);

  // Redirect back to #/organizationIdOrAll/multi-point-installations if this page is visited and the creation process was not started
  useEffect(() => {
    if (!state.open) {
      window.location.hash = `#/${organizationIdOrAll}/multi-point-installations`;
    }
  }, [state.open]);

  return (
    <Fragment>
      <AppBar>
        <AppBarTitle>
          <BackButton />
          {state.setup.name}
        </AppBarTitle>
      </AppBar>
      <div className={styles.wrapper}>
        <SensorRearranger
          positions={state.reorder.positions}
          onAddSensor={() => setShowSensorSidebar(true)}
          onDeleteSensor={serialNumber =>
            dispatch({
              type:
                MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_REMOVE_SENSOR,
              serialNumber,
            })
          }
          onReorderSensors={serialNumbers =>
            dispatch({
              type:
                MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_SET_SENSOR_ORDER,
              serialNumbers,
            })
          }
          onSetSpacingRight={(serialNumber, spacingRight) => {
            dispatch({
              type:
                MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_SET_SPACING_RIGHT,
              serialNumber,
              spacingRight,
            });
          }}
        />
      </div>
      <AppBar>
        <AppBarSection />
        <AppBarSection>
          <HorizontalForm>
            <Button
              variant="underline"
              href={`#/${organizationIdOrAll}/multi-point-installations`}
            >
              Cancel
            </Button>
            <Button
              variant="filled"
              disabled={state.reorder.positions.length < 2}
              onClick={() => {
                createMpis(dispatch, history, sessionToken, organizationIdOrAll, {
                  name: state.setup.name,
                  sensor_height: parseFloat(state.setup.height),
                  config: {},
                  sensors: state.reorder.positions.map((i, position) =>
                    i.spacingRight && i.spacingRight.length > 0
                      ? {
                          sensor_serial: i.serialNumber,
                          position,
                          spacing_right: parseFloat(i.spacingRight),
                        }
                      : { sensor_serial: i.serialNumber, position },
                  ),
                });
              }}
              data-test-id="mpi-create-button"
            >
              Create
            </Button>
          </HorizontalForm>
        </AppBarSection>
      </AppBar>

      <AddSensorSidebar
        open={showSensorSidebar}
        onDismiss={() => setShowSensorSidebar(false)}
        onSubmit={sensors => {
          dispatch({
            type:
              MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_ADD_SENSORS,
            sensors,
          });
          setShowSensorSidebar(false);
        }}
      />
    </Fragment>
  );
};

export default MultiPointInstallationCreationStepReorder;
